<template>
  <b-card>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="mb-0">User Sign-ons — {{ month }}</h6>
      <span class="text-muted small">Total: {{ totalSignons }}</span>
    </div>
    <div v-if="loading" class="text-center py-4">
      <b-spinner small></b-spinner>
    </div>
    <div v-else-if="bars.length === 0" class="text-center text-muted py-4 small">No data available</div>
    <div v-else class="chart-wrap">
      <svg :viewBox="`0 0 ${svgWidth} ${svgHeight}`" width="100%" :height="svgHeight">
        <!-- Y gridlines & labels -->
        <g v-for="(tick, i) in yTicks" :key="'y'+i">
          <line :x1="paddingLeft" :x2="svgWidth - paddingRight"
                :y1="yPos(tick)" :y2="yPos(tick)"
                stroke="#e0e0e0" stroke-width="1" />
          <text :x="paddingLeft - 6" :y="yPos(tick) + 4"
                text-anchor="end" font-size="10" fill="#888">{{ tick }}</text>
        </g>
        <!-- Bars -->
        <g v-for="(bar, i) in bars" :key="'b'+i">
          <rect
            :x="bar.x"
            :y="yPos(bar.count)"
            :width="barWidth - 2"
            :height="chartHeight - yPos(bar.count) + paddingTop"
            fill="#5e72e4"
            rx="2"
          />
          <!-- X label -->
          <text
            :x="bar.x + (barWidth - 2) / 2"
            :y="svgHeight - 4"
            text-anchor="middle"
            font-size="9"
            fill="#555"
          >{{ bar.label }}</text>
          <!-- Value on top -->
          <text
            :x="bar.x + (barWidth - 2) / 2"
            :y="yPos(bar.count) - 3"
            text-anchor="middle"
            font-size="9"
            fill="#5e72e4"
          >{{ bar.count }}</text>
        </g>
        <!-- X axis line -->
        <line :x1="paddingLeft" :x2="svgWidth - paddingRight"
              :y1="svgHeight - paddingBottom" :y2="svgHeight - paddingBottom"
              stroke="#ccc" stroke-width="1" />
      </svg>
    </div>
  </b-card>
</template>

<script>
import _axios from '@/services/axios';
import config from '@/settings/config.js';

export default {
  name: 'UserSignonChart',
  data() {
    return {
      loading: false,
      month: '',
      totalSignons: 0,
      dailyBreakdown: [],
      paddingLeft: 32,
      paddingRight: 10,
      paddingTop: 20,
      paddingBottom: 24,
      svgWidth: 600,
      svgHeight: 180,
    };
  },
  computed: {
    chartHeight() {
      return this.svgHeight - this.paddingTop - this.paddingBottom;
    },
    maxCount() {
      return Math.max(...this.dailyBreakdown.map(d => d.count), 1);
    },
    yTicks() {
      const max = this.maxCount;
      const step = Math.ceil(max / 4);
      const ticks = [];
      for (let v = 0; v <= max; v += step) ticks.push(v);
      return ticks;
    },
    barWidth() {
      const count = this.dailyBreakdown.length || 1;
      return (this.svgWidth - this.paddingLeft - this.paddingRight) / count;
    },
    bars() {
      return this.dailyBreakdown.map((d, i) => ({
        x: this.paddingLeft + i * this.barWidth,
        count: d.count,
        label: new Date(d.date).getDate(),
      }));
    },
  },
  methods: {
    yPos(value) {
      const ratio = value / this.maxCount;
      return this.paddingTop + this.chartHeight * (1 - ratio);
    },
    fetchSummary() {
      this.loading = true;
      _axios.get(`${config.gateway}admin/internal/report/Users/Summary`)
        .then(res => {
          this.month = res.data.month;
          this.totalSignons = res.data.totalSignons;
          this.dailyBreakdown = res.data.dailyBreakdown;
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false; });
    },
  },
  mounted() {
    this.fetchSummary();
  },
};
</script>

<style scoped>
.chart-wrap {
  overflow-x: auto;
}
</style>
